module.exports = __webpack_public_path__ + "static/media/fast_game.d205f438.svg";